exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userinfo[data-v-c2b42d0a]{text-align:center;float:left;overflow:hidden;position:absolute}.userinfo .hand-photo[data-v-c2b42d0a]{float:left;width:25px;height:25px;border-radius:50%;background:#ccc;color:#fff;font-size:25px;overflow:hidden;line-height:25px;text-indent:-4px;letter-spacing:-4px}.userinfo .p1[data-v-c2b42d0a],.userinfo .p2[data-v-c2b42d0a]{margin-left:10px;display:block;float:left;line-height:25px}.userinfo .p2[data-v-c2b42d0a]{color:#b2b2b2}.time[data-v-c2b42d0a]{line-height:16px}.content[data-v-c2b42d0a]{padding:10px 0}.ivu-checkbox-group-item[data-v-c2b42d0a]{display:block!important;margin:10px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-c2b42d0a","scoped":true,"sourceMap":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dialysisProcess/dialysisArea/dialysisSyndrome.vue
// module id = AeV0
// module chunks = 0